export const getIncident = /* GraphQL */ `
  query GetIncident($id: ID!) {
    getIncident(id: $id) {
      id
      geohash
      lat
      lng
      date
      name
      typeId
      type {
        id
        name
        iconName
        dataAccess
        category
      }
      status
      evidence {
        items {
            id
            lat
            lng
            geohash                       
            userId
            user {
                userId
                anonymous
                email
                lastName
                firstName
                postalCode
                phoneNumber
                createdAt
                updatedAt
            }
            anonymous
            description
            media {
                items {
                    id
                    incidentId
                    evidenceId
                    userId                    
                    lat
                    lng
                    geohash
                    filename
                    mediaType
                    createdAt
                    updatedAt
                    evidenceMediaId
                }
            }
            type
            status
            date
        }
      }      
    }
  }
`;